var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'toggler',
    { 'toggler--off': (!_vm.value) },
    { 'toggler--on': (_vm.value) } ],on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggler__body"},[_c('div',{staticClass:"toggler__rect"})])}]

export { render, staticRenderFns }